import { cancel, select, put, take, call } from 'redux-saga/effects';
import get from 'lodash/get';
import head from 'lodash/head';

import {
  hasProviderProfileSelector,
  providerProfileIdSelector,
  selectIsLoggedTeam,
  targetUserIdSelector,
} from '../../context/selectors';
import {
  redirectToHealthBoard,
  redirectToHealthBoardEmpty,
} from '../../../utils/appointments/redirect-utils';
import * as practiceProvidersReq from '../../schedule/requests/practice-providers-req';
import * as caregiverCircle from '../../circles/caregiver';
import * as appState from '../../data/app-state-req';
import { healthBoardActions } from '../root';

export default function* validateHealthBoardSaga() {
  const providerId = yield select(providerProfileIdSelector);
  const isProvider = yield select(hasProviderProfileSelector);
  const isTeam = yield select(selectIsLoggedTeam);

  if (!isProvider) yield put(caregiverCircle.actions.send());

  if (isProvider) {
    yield put(practiceProvidersReq.actions.send({ id: providerId }));
    yield put(appState.actions.send());
  }

  if (isTeam) {
    const { payload: practiceProviders } = yield take(
      practiceProvidersReq.consts.SUCCEED,
    );

    const targetId = yield select(targetUserIdSelector);

    if (practiceProviders.length > 0) {
      const hasInList = practiceProviders.some(({ id }) => id === targetId);
      const id = hasInList ? targetId : get(head(practiceProviders), 'id');

      yield call(redirectToHealthBoard, id);
      yield put(healthBoardActions.toggleValidation(false));
    } else {
      yield call(redirectToHealthBoardEmpty);
    }

    yield cancel();
  }

  yield put(healthBoardActions.toggleValidation(false));
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/validate-healthboard-saga.js